import React, { useRef } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { forceUpdate } from '../../HOME/REDUX/actions';
import { setSelected, setStack, removeNumber, setScore, updateStats, setPoints, setPointsVisible } from '../REDUX/actions';
import _ from 'lodash';
import { GAME_PAGE } from '../../HOME/const';
import { delay, playSound } from '../../HOME/utils';
import { SECS_PER_LEVEL } from '../const';

export const levelInfo = level => {
  let numbers;

  switch (level) {
    case 0:
    case 1:
      numbers = '128,64,32,16,8,4,2,1';
      break;
    case 2:
      numbers = '1458,486,162,54,18,6,2,729,243,81,27,9,3,1';
      break;
    case 3:
      numbers = '3072,768,192,48,12,3,2048,512,128,32,8,2,1024,256,64,16,4,1';
      break;
    case 4:
      numbers = '12500,2500,500,100,20,4,9375,1875,375,75,15,3,6250,1250,250,50,10,2,3125,625,125,25,5,1';
      break;
    case 5:
      numbers = '33840,5640,940,152,30,5,27072,4512,752,144,24,4,20304,3384,564,108,18,3,13536,2256,376,72,12,2,6768,1128,188,36,6,1';
      break;
    case 6:
      numbers = '14406,2058,294,42,6,12005,1715,245,35,5,9604,1372,196,28,4,7203,1029,147,21,3,4802,686,98,14,2,2401,343,49,7,1';
      break;
    case 7:
      numbers = '3584,448,56,7,3072,384,48,6,2560,320,40,5,2048,256,32,4,1536,192,24,3,1024,128,16,2,512,64,8,1';
      break;
    case 8:
      numbers = '5832,648,72,8,5103,567,63,7,4374,486,54,6,3645,405,45,5,2916,324,36,4,2187,243,27,3,1458,162,18,2,729,81,9,1';
      break;
    default:
  }

  numbers = _.map(_.words(numbers), n => Number(n));
  const cols = numbers.length / level;

  return { numbers, max: _.sum(_.take(numbers, cols)) };
};

const NumPad = props => {
  const { preSelected, page, stack } = props;
  const level = page === GAME_PAGE ? props.level : 2;
  const cellHeight = page === GAME_PAGE ? props.cellHeight : 30;
  const rowHeight = `${cellHeight}px `;
  const l = useRef({});
  const selected = (preSelected ? preSelected : props.selected) || [];
  const { numbers } = levelInfo(level);
  const cols = numbers.length / level;
  const colWidth = `${321 / cols}px `;
  const grid = `${_.repeat(rowHeight, level)}/${_.repeat(colWidth, cols)}`;

  const handleTouch = i => {
    l.current.touch = true;
    handleClick(i);
  };

  const handleMouseDown = i => {
    if (!l.current.touch) {
      handleClick(i);
    }
  };

  const handleClick = i => {
    if (page !== GAME_PAGE) {
      return;
    }

    playSound(props, 'tap');

    let arr = [];
    const n = numbers[i];

    if (isSelected(n)) {
      arr = _.filter(selected, s => s !== n);
    } else {
      arr = selected;
      const r = _.find(selected, s => _.indexOf(numbers, s) % cols === i % cols);

      if (r) {
        arr = _.filter(selected, s => s !== r);
      }

      arr.push(n);
    }

    props.setSelected(arr);
    props.forceUpdate();

    const sum = _.sum(arr);

    for (let i = 0; i < 2; i++) {
      const index = stack.length - i - 1;

      if (index < 0) {
        break;
      }

      const num = stack[index];

      if (sum === num) {
        let p = _.round(num / 10);
        p = Math.max(p, 1);

        playSound(props, p < 1350 ? 'coin1' : num < 2700 ? 'coin2' : 'coins');

        props.setPoints(p);
        props.setPointsVisible(true);

        props.removeNumber(num);

        if (!props.practice) {
          props.setScore((props.score || 0) + p);
        }

        delay(() => props.setSelected([]));
        return;
      }
    }
  };

  const isSelected = n => {
    return _.includes(selected, n);
  };

  const p = (100 * props.secs) / SECS_PER_LEVEL;
  const sum = _.sum(selected);
  const backgroundImage =
    page === GAME_PAGE ? `linear-gradient(to right, rgba(120,50,120,0.35) ${100 - p}%, gainsboro ${100 - p}%, gainsboro ${p}%)` : 'initial';

  return (
    <div>
      <div className="nm-195" style={{ backgroundImage }}>
        <span style={{ gridArea: '1/1', transform: 'translateY(1px)', justifySelf: 'center', display: `${sum ? 'initial' : 'none'}` }}>
          {sum}
        </span>
      </div>
      <div className="nm-number-pad" style={{ grid }}>
        {_.map(numbers, (n, i) => {
          const row = Math.floor(i / cols) + 1;
          const col = (i % cols) + 1;
          const sel = isSelected(n);
          const background = sel ? 'rgb(50,0,50)' : 'rgba(255,255,255,0.1)';
          const color = sel ? 'pink' : 'gainsboro';

          return (
            <div
              key={i}
              className="nm-number-pad-cell"
              style={{ gridArea: `${row}/${col}`, background, color }}
              onTouchStart={() => handleTouch(i)}
              onMouseDown={() => handleMouseDown(i)}>
              <span style={{ transform: 'translateY(1px)' }}>{n}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { forceUpdate, setSelected, setStack, removeNumber, setScore, updateStats, setPoints, setPointsVisible }
)(NumPad);
